import { render, staticRenderFns } from "./RemindARForm.vue?vue&type=template&id=3523c607"
import script from "./RemindARForm.vue?vue&type=script&lang=js"
export * from "./RemindARForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports